export default __webpack_public_path__ + "static/media/die-mitte.bffbd592.svg";